import React, { ReactNode } from 'react';
import { Link } from '../components/Typography';

export interface NavigationItemProps {
  href?: string;
  icon?: ReactNode;
  children: ReactNode;
  active?: boolean;
  onClick?: () => void;
  className?: string;
}

export const NavigationItem: React.FC<NavigationItemProps> = ({
  href,
  icon,
  children,
  active = false,
  onClick,
  className = '',
}) => {
  const baseClasses =
    'flex items-center gap-3 px-3 py-2 text-sm hover:bg-base-200 rounded transition-colors w-full';
  const activeClasses = active ? 'bg-base-200' : '';
  const combinedClasses = `${baseClasses} ${activeClasses} ${className}`;

  const content = (
    <>
      {icon && <span className="flex-shrink-0 text-base-content/70">{icon}</span>}
      <span className={`truncate ${active ? 'font-medium text-primary' : 'text-base-content'}`}>
        {children}
      </span>
    </>
  );

  if (href) {
    return (
      <Link
        href={href}
        variant="nav"
        underline="none"
        className={combinedClasses}
        {...(onClick && { onClick })}
      >
        {content}
      </Link>
    );
  }

  return (
    <button type="button" className={`${combinedClasses} w-full text-left`} onClick={onClick}>
      {content}
    </button>
  );
};
